import Immutable from "seamless-immutable";

export const NOTIFICATION_IDS = {
	SELECTION_MAX_REACHED: "SELECTION_MAX_REACHED",
	INVALID_URL: "INVALID_URL",
	ERROR: "ERROR",
	PROMPT: "PROMPT",
	INVALID_PUBLIC_ID: "INVALID_PUBLIC_ID",
	NO_NEW_FILES: "NO_NEW_FILES",
	IMAGE_PURCHASED: "IMAGE_PURCHASED",
	VIDEO_PURCHASED: "VIDEO_PURCHASED",
	PURCHASE_FAILED: "PURCHASE_FAILED",
	IMAGE_ACQUIRED: "IMAGE_ACQUIRED",
	VIDEO_ACQUIRED: "VIDEO_ACQUIRED",
	ACQUISITION_FAILED: "ACQUISITION_FAILED",
	SERVICE_LOGGED_OUT: "SERVICE_LOGGED_OUT",
};

export default Immutable({
	[NOTIFICATION_IDS.SELECTION_MAX_REACHED]: {
		id: NOTIFICATION_IDS.SELECTION_MAX_REACHED,
		text: "notifications.limit_reached",
	},

	[NOTIFICATION_IDS.INVALID_URL]: {
		id: NOTIFICATION_IDS.INVALID_URL,
		text: "notifications.invalid_add_url",
	},

	[NOTIFICATION_IDS.ERROR]: {
		id: NOTIFICATION_IDS.ERROR,
		text: "notifications.general_error",
	},

	[NOTIFICATION_IDS.PROMPT]: {
		id: NOTIFICATION_IDS.PROMPT,
		text: "notifications.general_prompt",
		actions: [],
	},

	[NOTIFICATION_IDS.INVALID_PUBLIC_ID]: {
		id: NOTIFICATION_IDS.INVALID_PUBLIC_ID,
		text: "notifications.invalid_public_id",
	},

	[NOTIFICATION_IDS.NO_NEW_FILES]: {
		id: NOTIFICATION_IDS.NO_NEW_FILES,
		text: "notifications.no_new_files",
	},

	[NOTIFICATION_IDS.IMAGE_PURCHASED]: {
		id: NOTIFICATION_IDS.IMAGE_PURCHASED,
		text: "notifications.image_purchased",
		type: "success",
		actions: [{
			textColor: "link",
			label: "notifications.great",
		}],
	},

	[NOTIFICATION_IDS.VIDEO_PURCHASED]: {
		id: NOTIFICATION_IDS.VIDEO_PURCHASED,
		text: "notifications.video_purchased",
		type: "success",
		actions: [{
			textColor: "link",
			label: "notifications.great",
		}],
	},

	[NOTIFICATION_IDS.PURCHASE_FAILED]: {
		id: NOTIFICATION_IDS.PURCHASE_FAILED,
		text: "notifications.purchase_failed",
	},

	[NOTIFICATION_IDS.IMAGE_ACQUIRED]: {
		id: NOTIFICATION_IDS.IMAGE_ACQUIRED,
		text: "notifications.image_acquired",
		type: "success",
		actions: [{
			textColor: "link",
			label: "notifications.great",
		}],
	},

	[NOTIFICATION_IDS.VIDEO_ACQUIRED]: {
		id: NOTIFICATION_IDS.VIDEO_ACQUIRED,
		text: "notifications.video_acquired",
		type: "success",
		actions: [{
			textColor: "link",
			label: "notifications.great",
		}],
	},

	[NOTIFICATION_IDS.ACQUISITION_FAILED]: {
		id: NOTIFICATION_IDS.ACQUISITION_FAILED,
		text: "notifications.acquisition_failed",
	},

	[NOTIFICATION_IDS.SERVICE_LOGGED_OUT]: {
		id: NOTIFICATION_IDS.SERVICE_LOGGED_OUT,
		text: "notifications.service_logged_out",
	},
});
